'use client';

import { Text } from '@backyard-ui/core';

import useIsClient from '@/presenters/hooks/use-is-client';

function TalkToExpertsLink() {
  const isClient = useIsClient();

  const currentURL = isClient ? window.location.href : '';
  const text = `Ol%C3%A1,+gostaria+de+informações+sobre:+${currentURL}`;

  return (
    <Text
      size="sm"
      color="green-600"
      weight="bold"
      decoration="underline"
      asChild
    >
      <a
        href={`https://api.whatsapp.com/send?phone=551140071380&text=${text}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        Fale com especialistas
      </a>
    </Text>
  );
}

export default TalkToExpertsLink;
